<header>
    <div class="fixed-top bg-light">
        <a class="navbar-brand" style="margin-left: 1.5rem" routerLink="/">
            <img src="assets/images/siemens-logo.svg" width="89" height="15" alt="Siemens" class="ml-2 mt-4">
        </a>
        <nav class="navbar  navbar-expand-lg navbar-light bg-light px-2">
            <a class="nav-link text-dark">
                <span class="text-head"><strong>SiePro</strong></span><br>
                <span class="text-small">Siemens procurement</span>
            </a>
        </nav>
    </div>
</header>
<div class="rfq">
    <div class="rfq__content py-4">
        <div class="card mt-1">
            <div class="card-header p-4">
                <div class="d-flex justify-content-between pb-3">
                    <h5 class="align-self-center mb-1">
                        Request for Quotation(RFQ)
                    </h5>
                </div>
            </div>
            <div class="mt-1 card-body">
                <div class="p-0">
                    <h6> Basic Information </h6>
                    <form class="mt-2 was-validated" [formGroup]="rfqForm">
                        <div class="row mb-2">
                            <div class="col-md-3">
                                <label class="form-label text-small" for="Template Name">
                                    Requirement Name <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="text" 
                                    placeholder="Requirement Name" formControlName="template_name"
                                    [(ngModel)]="rfqTemplate.template_name" readonly>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label text-small" for="RFQ Date">
                                    RFQ Date <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="date" id="RFQ Date"
                                    placeholder="RFQ Date" formControlName="rfq_date" [(ngModel)]="rfqTemplate.rfq_date"
                                     readonly>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label text-small" for="RFQ Time">
                                    RFQ Time <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="time" id="RFQ Time"
                                    placeholder="RFQ Time" formControlName="rfq_time" [(ngModel)]="rfqTemplate.rfq_time"
                                     readonly>
                            </div>
                        </div>
                    </form>
                    <hr>
                    <h6>Buyer and Supplier Information</h6>
                    <div class="mt-3 accordion" id="accordionExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Buyer Information
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <form class="was-validated" [formGroup]="rfqForm">
                                        <div class="row mb-2">
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Buyer:">
                                                    Buyer: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text" id="Buyer:"
                                                    placeholder="Buyer:" formControlName="buyer"
                                                    [(ngModel)]="rfqBuyer.user_name"  readonly>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Email Address">
                                                    Email Address: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="email"
                                                    id="Email Address" placeholder="Email Address"
                                                    formControlName="email" [(ngModel)]="rfqBuyer.user_email"  readonly>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Mobile No">
                                                    Mobile No : <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text" id="Mobile No"
                                                    placeholder="Mobile No" formControlName="mobile_no"
                                                    [(ngModel)]="rfqBuyer.mobile_no"  readonly>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Supplier Information
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <form class="was-validated" [formGroup]="rfqForm">
                                        <div class="row mb-2">
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Buyer:">
                                                    Supplier: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text" id="Supplier:"
                                                    placeholder="Supplier:" formControlName="name"
                                                    [(ngModel)]="rfqSupplier.name"  readonly>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Email Address">
                                                    Email Address: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="email"
                                                    id="Email Address" placeholder="Email Address"
                                                    formControlName="email" [(ngModel)]="rfqSupplier.email"  readonly>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Mobile No">
                                                    Mobile No : <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="number" id="Mobile No"
                                                    placeholder="Mobile No" formControlName="contact_number"
                                                    [(ngModel)]="rfqSupplier.contact_number"  readonly>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Mobile No">
                                                    Created Date and Time : <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text" id="Create Date Time"
                                                    placeholder="Create Date and Time" formControlName="create_date_time"
                                                    [(ngModel)]="rfqSupplier.create_date_time"  readonly>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Buyer:">
                                                    City: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text" id="City:"
                                                    placeholder="City:" formControlName="city"
                                                    [(ngModel)]="rfqSupplier.city" readonly >
                                            </div>
                                            <div class="col-md-3">
                                                <label class="form-label text-small" for="Country:">
                                                    Country: <sup style="color :red">*</sup>
                                                </label>
                                                <input class="form-control form-control-sm" type="text"
                                                    id="Country" placeholder="Country"
                                                    formControlName="country" [(ngModel)]="rfqSupplier.country" readonly >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Siemens Remarks
                              </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                              <div class="accordion-body">
                                <form [formGroup]="rfqForm">
                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="form-label text-small" for="Payment Terms:">
                                                Payment Terms: <sup style="color :red">*</sup>
                                            </label>
                                            <input class="form-control form-control-sm" type="text"
                                                id="Payment Terms:" [(ngModel)]="rfqTemplate.siemens_payment_terms"
                                                placeholder="Payment Terms:" formControlName="payment_term"
                                                readonly>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label text-small" for="Quotation Deadline:">
                                                Quotation Deadline: <sup style="color :red">*</sup>
                                            </label>
                                            <input class="form-control form-control-sm" type="date"
                                                [(ngModel)]="rfqTemplate.siemens_qt_deadline"
                                                id="Quotation Deadline:" placeholder="Quotation Deadline:" 
                                                formControlName="quotation" readonly>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label text-small" for="Required date of Delivery:">
                                                Required date of Delivery: <sup style="color :red">*</sup>
                                            </label>
                                            <input class="form-control form-control-sm" type="date"
                                                [(ngModel)]="rfqTemplate.siemens_req_date_deli"
                                                id="Required date of Delivery:" formControlName="date"
                                                placeholder="Required date of Delivery:" readonly>
                                        </div>
                                    </div>
                                </form>
                             </div>
                            </div>
                          </div>
                        <div>
                            <h6 class="mt-2">General Terms and Conditions</h6>
                            <p>
                                Unless explicitly stated on this RFQ or agreed otherwise in writing, our current valid
                                General
                                Terms and Conditions ("GTC") shall apply to this RFQ. GTC can be downloaded from
                                <a href="http://siemens.co.in/scm">http://siemens.co.in/scm</a> or be
                                forwarded directly upon request.
                            </p>
                        </div>
                    </div>
                    <hr>
                    <h6>Quotation Details</h6>
                    <div class="mb-3">
                        <p>Dear Supplier</p>
                        <p>
                            Siemens Requests your lowest price quotations for
                            the items specified in this Request for Quotation.
                            We will be glad if you will state your prices and any other relevant information in
                            this regard.
                        </p>
                    </div>
                    <form class="mt-3 was-validated" [formGroup]="rfqForm">
                        <div class="row mb-2">
                            <div class="col-md-3">
                                <label class="form-label text-small" for="Payment Terms:">
                                    Payment Terms: <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="text" id="Payment Terms:"
                                    [(ngModel)]="rfqTemplate.vendor_payment_terms" placeholder="Payment Terms:"
                                    formControlName="vendor_payment_terms" required>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label text-small" for="Incoterms 1:">
                                    Incoterms 1:
                                    <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="text" id="Incoterms 1:"
                                    [(ngModel)]="rfqTemplate.vendor_incoterms_1" placeholder="Incoterms 1:"
                                    formControlName="vendor_incoterms_1" required>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label text-small" for="Incoterms 2:">
                                    Incoterms Description:
                                    <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="text" id="Incoterms 2:"
                                    [(ngModel)]="rfqTemplate.vendor_incoterms_2" placeholder="Incoterms 2:"
                                    formControlName="vendor_incoterms_2" required>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label text-small" for="Taxes Applicable:">
                                    Taxes Applicable: <sup style="color :red">*</sup>
                                </label>
                                <select class="form-control form-control-sm" type="text" id="Taxes Applicable:"
                                    formControlName="vendor_tax_applicable" required>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </select>
                            </div>
                            <div class="col-md-3 mt-3">
                                <label class="form-label text-small" for="Delivery Date:">
                                    Delivery Date: <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="date" id="Delivery Date:"
                                    [(ngModel)]="rfqTemplate.vendor_delivery_date" placeholder="Delivery Date:"
                                    formControlName="vendor_delivery_date" required>
                            </div>

                            <div class="col-md-3 mt-3">
                                <label class="form-label text-small" for="Salesperson Name">
                                    Salesperson Name <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="text" id="Salesperson Name"
                                    placeholder="Salesperson Name" formControlName="sales_person_name" required>
                            </div>

                            <div class="col-md-3 mt-3">
                                <label class="form-label text-small" for="Salesperson Mobile">
                                    Salesperson Mobile <sup style="color :red">*</sup>
                                </label>
                                <input class="form-control form-control-sm" type="tel" id="Salesperson Mobile" pattern="[0-9]{10}"
                                    placeholder="Salesperson Mobile" formControlName="sales_person_number" required>
                            </div>
                        </div>
                    </form>
                    <div class="mt-3 table-wrapper table-responsive">
                        <form class="was-validated" [formGroup]="rfqForm">
                            <div formArrayName="quotationDetails">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Sl No.</th>
                                        <th scope="col">Material/service</th>

                                        <th colspan="2" scope="col">
                                            <table>
                                                <thead>
                                                    <tr colspan="2">
                                                        <th scope="col">Siemens Preferred</th>
                                                    </tr>
                                                    <hr>
                                                    <tr>
                                                        <th scope="col" class="text-center"
                                                            style="min-width: 400px !important">Make</th>
                                                        <th scope="col" class="text-center"
                                                            style="min-width: 400px !important">PO Text</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </th>
                                        <th scope="col">HSN / SAC</th>
                                        <th scope="col">UOM</th>
                                        <th scope="col">Quantity</th>
                                        <th colspan="3" scope="col">
                                            <table>
                                                <thead>
                                                    <tr colspan="3">
                                                        <th scope="col">Cost</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Currency</th>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Unit Price<sup style="color :red">*</sup></th>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Tax(In %)<sup style="color :red">*</sup></th>

                                                </thead>
                                            </table>
                                        </th>
                                        <th colspan="2" scope="col">
                                            <table>
                                                <thead>
                                                    <tr colspan="2">
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Packing Percentage or Amount</th>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Packing Charge<sup style="color :red">*</sup></th>

                                                    </tr>
                                                </thead>
                                            </table>
                                        </th>
                                        <th colspan="2" scope="col">
                                            <table>
                                                <thead>
                                                    <tr colspan="2">
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Freight Percentage or Amount</th>
                                                        <th scope="col" class="text-center" style="min-width: 125px">
                                                            Freight Charge<sup style="color :red">*</sup></th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </th>
                                        <th scope="col">Lead Time (In Days)<sup style="color :red">*</sup></th>
                                        <th scope="col">Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let control of formArr.controls; let i = index" [formGroupName]="i">
                                        <th scope="row">{{i+1}}.</th>
                                        <td>
                                            <input type="text" class="form-control" readonly
                                                 placeholder="Material/Service"
                                                formControlName="material_code">
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control"
                                             placeholder="Siemens Make"
                                                formControlName="siemens_make" required>
                                        </td>
                                        <td>
                                            <textarea type="text"  class="form-control"
                                             placeholder="Siemens Model"
                                                formControlName="siemens_model" required></textarea>
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control"
                                             placeholder="HSN/SAC"
                                                formControlName="hsn_or_sac" readonly>
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control" 
                                                placeholder="UOM" formControlName="uom" readonly>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control"
                                             placeholder="Quantity"
                                                formControlName="quantity" readonly>
                                        </td>
                                        <td>
                                            <select class="form-select mb-2"
                                                formControlName="purchase_order_currency" >
                                                <option *ngFor="let currency of currencyList" [value]=currency>
                                                    {{currency}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control"
                                             placeholder="Unit Price"
                                                formControlName="unit_price" required>
                                        </td>
                                        <td>
                                            <select class="form-select mb-2"
                                                formControlName="tax">
                                                <option value="0">0%</option>
                                                <option value="5">5%</option>
                                                <option value="12">12%</option>
                                                <option value="18">18%</option>
                                                <option value="28">28%</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select class="form-select mb-2"
                                                formControlName="packing_percent_or_amount">
                                                <option value="Amount">Amount</option>
                                                <option value="Percentage">Percentage(%)</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control"
                                                placeholder="Packing Charge"
                                                formControlName="packing_charge" required>
                                        </td>
                                        <td>
                                            <select class="form-select mb-2"
                                                formControlName="freight_percent_or_amount" >
                                                <option value="Amount">Amount</option>
                                                <option value="Percentage">Percentage(%)</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control"
                                                placeholder="Freight Charge" 
                                                formControlName="freight_charge" required>
                                        </td>
                                        <td>
                                            <input type="number"  class="form-control"
                                             placeholder="Lead Time"
                                                formControlName="lead_time" required>
                                        </td>
                                        <td>
                                            <input type="text"  class="form-control" placeholder="Remarks"
                                                formControlName="remark"   required>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </form>
                    </div>
                    <hr>
                    <h6>Attachments</h6>
                    <div class="pe-3 attachment-container">
                        <div class="d-flex justify-content-end mb-2">
                            <button class="btn btn-outline-primary me-2 align-self-center" (click)="uploadAttachment()">
                                Upload
                            </button>
                        </div>
                        <div>
                            <section class="prUpload mt-3">
                                <div class="col-12 row mx-0">
                                    <div class="my-2 upload-view" *ngFor="let prFile of uploadedFiles">
                                        <div>
                                            <p class='mb-1'>
                                                {{prFile?.name}}
                                            </p>
                                            <p class="mb-0 font-small">
                                                {{(prFile.size/1024).toFixed(2)}} KB
                                            </p>
                                        </div>
                                        <div class='align-self-center'>
                                            <a class='pointer mx-2 cursor-pointer'
                                                (click)="downloadRFQtemplate(prFile)">
                                                <span class="fa fa-cloud-download fa-2x"></span>
                                            </a>
                                            <a class='pointer mx-2 cursor-pointer' (click)="deleteRFQtemplate(prFile)"
                                                *ngIf="userDetails?.gid === prFile?.uploaded_by">
                                                <span class="fa fa-trash fa-2x"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-md-flex justify-content-md-end">
            <button class="btn btn-primary" type="submit" [disabled]="!rfqForm.valid"
                (click)="onSubmit()">Submit</button>
        </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <h6 style="margin-left: 71px"> <i class="fa fa-check-circle"></i>  Successfully Submitted
                    </h6>
                </div>
            </div>
        </div>
    </div>
</div>